<template>
  <div v-if="showBanner" class="download-app-banner">
    <div class="banner-content">
      <BaseIcon
        icon-file="close-grey"
        :width="10"
        :height="10"
        @click="handleClose"
      />
      <BaseIcon
        icon-file="logo-icon"
        :width="60"
        :height="60"
        class="app-logo"
      />
      <div class="banner-text">
        <h2>{{ $t('download_app_title') }}</h2>
        <p>{{ $t('download_app_subtitle') }}</p>
      </div>
      <BaseButton
        :link="$t('playstoreUrl')"
        :is-external="true"
        class="cta-button rounded tiny grey"
      >
        {{ $t('download_app_cta') }}
      </BaseButton>
    </div>
  </div>
</template>

<script>
import { getCookie, setCookie } from '@/utils/cookies';

export default {
  name: 'DownloadApp',

  data() {
    return {
      showBanner: false
    };
  },

  computed: {
    isAndroid() {
      return /android/i.test(navigator.userAgent);
    }
  },

  mounted() {
    if (!getCookie('hide-download-app-banner') && Math.random() < 0.8) {
      setCookie('hide-download-app-banner', 'true', 300);
    }

    this.showBanner =
      getCookie('hide-download-app-banner') !== 'true' &&
      this.isAndroid &&
      this.$country.currentCountry !== 'se';
  },

  methods: {
    handleClose() {
      setCookie('hide-download-app-banner', 'true', 30);
      this.showBanner = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.download-app-banner {
  background: #fff;
  padding: 8px 16px;
  border-bottom: 1px solid #e8e8e8;
}

.banner-content {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.app-logo {
  margin: 0 12px;
  flex-shrink: 0;
}

.banner-text {
  flex-grow: 1;
  margin-right: 16px;

  h2 {
    font-size: 16px;
    font-weight: 700;
    margin: 0;
  }

  p {
    font-size: 13px;
    font-weight: 600;
    color: #72777e;
    margin: 2px 0 0;
  }
}

.cta-button {
  white-space: nowrap;
}
</style>
